module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropdown.ddbb8461.svg";